import { IconPlus as TablerIconPlus } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconPlus = /*#__PURE__*/ createOutlineIcon(TablerIconPlus, 'IconPlus');
